var React = require('react');

function PaginationRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m485.91-480-184-184L376-738.09 634.09-480 376-221.91 301.91-296l184-184Z"}));
}

PaginationRight.defaultProps = {"height":"24","viewBox":"0 -960 960 960","width":"24"};

module.exports = PaginationRight;

PaginationRight.default = PaginationRight;
